import moment from 'moment'
import momentTZ from 'moment-timezone'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['getFacilityTimezone'])
  },
  filters: {
    $_datetimeFilter_date(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    $_datetimeFilter_timestamp(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    $_datetimeFilter_timestamp_no_seconds(value) {
      return moment(value).format('YYYY-MM-DD HH:mm')
    },
    $_datetimeFilter_ending(value) {
      return moment(value).format('MM/DD HH:mm')
    }
  },

  methods: {
    $_datetimeMethod_test() {
      let now = this.$_datetimeMethod_nowInZone(this.getFacilityTimezone)
      return this.$_datetimeMethod_formatTimestamp(now)
    },
    $_datetimeMethod_formatNowInZone(timezone) {
      let now = this.$_datetimeMethod_nowInZone(timezone)
      return this.$_datetimeMethod_formatTimestamp(now)
    },
    $_datetimeMethod_nowInZone(timezone) {
      let now = moment()
      return momentTZ(now).tz(timezone)
    },

    $_datetimeMethod_timeInZone(value, timezone) {
      return momentTZ(value).tz(timezone)
    },
    $_datetimeMethod_currentTimeInZone(timezone, format) {
      return this.$_datetimeMethod_formatTimeInZone(moment(), timezone, format)
    },
    $_datetimeMethod_formatTimeInZone(value, timezone, format) {
      return momentTZ(value)
        .tz(timezone)
        .format(format)
    },
    $_datetimeMethod_formatTimeInIso(value, timezone) {
      return moment(momentTZ(value).tz(timezone)).toISOString()
    },
    $_datetimeMethod_formatTimeHoursMinutes(value) {
      return moment(value).format('HH:mm')
    },
    $_datetimeMethod_formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    $_datetimeMethod_formatTimestamp(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
